import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { Request } from "../../hooks/Request";
import {
  numberWithDecimals,
  roundUpCustom,
  validateArray,
} from "../../utils/validate";
import * as numeros_a_palabras from "numeros_a_palabras";

const styles = StyleSheet.create({
  page: {
    // Sin padding ni border
    size: "LETTER",
    fontSize: 7.8,
    position: "relative", // necesario para que el fondo absoluto se refiera a este contenedor
  },
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  bgImage: {
    position: "absolute",
    top: "0%",
    left: "0%",
    width: "105%", // mantienes tu tamaño mayor
    height: "100%", // centra la imagen
    opacity: 0.5,
  },
  content: {
    position: "relative",
    padding: 20, // aquí defines el padding del contenido sin afectar la imagen
  },
  title: {
    textAlign: "center",
    fontSize: 25,
    marginBottom: 10,
    fontWeight: "bold",
    paddingTop: 50,
  },

  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 40,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginBottom: 4,
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  lineH: {
    width: 1,
    backgroundColor: "#000",
    marginHorizontal: 10,
  },
  sectionTitle: {
    fontSize: 10,
    marginTop: 12,
    marginBottom: 4,
    fontWeight: "bold",
  },
  subTitle: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 2,
    fontWeight: "bold",
  },
  smallText: {
    fontSize: 10,
  },
  lefText: {
    fontSize: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  subTotal: {
    fontSize: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    fontWeight: "bold",
    paddingTop: 10,
  },

  footer: {
    // marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#f8f5f5ff",
    paddingTop: 5,
  },
  rowItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2,
  },

  cellItem: {
    fontSize: 10,
  },
});

const listFields = [
  "fechaDeCotización",
  "descripciónDeLaMercancía",
  "cm-003-FacturaComercial",
  "bultos",
  "peso",
  "a4AduanaDeDespacho",
  "asignarRégimenDeImportación",

  // "tipoDeDespacho",
  // "proveedor",
  // "nroFacturaComercial",
  // "piNro",
  // "nroBl",
  // "nroDeContenedor",
  // "notaDeValor",
  // "tipoDeCambioProforma",

  "a-TotalTributos",
  "b-TotalTributos",
  "c-TotalTributos",
  "notaDeLaCotizacion",

  // "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  // "descripciónDeLaMercancía",
  // "partidaArancelaria",
  // "valoresNominales",
  // //
  // "fechaDeCotización",
  // "tipoDeDespacho",
  // "a4AduanaDeDespacho",
  // "proveedor",
  // "nroFacturaComercial",
  // "piNro",
  // "nroBl",
  // "tipoDeCambioProforma",
  // "nroDeContenedor",
  // //
  // "a-TotalTributos",
  // "b-TotalTributos",
  // "c-TotalTributos",
  // "porcentajeParaCalcularIva",
  // "notaDeLaCotizacion",
];

const fondoURL =
  "https://res.cloudinary.com/dh15miacl/image/upload/fondo_bffzk1.jpg";
//imagen de Cloudinary

const CustomsClearanceQuote = (props) => {
  const { procedure, notesValueData = [] } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/dataValues?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });

  if (!loading || !data) {
    return null;
  }

  const calculateTotals = (data, totalTributos = 0) => {
    const totalA = Number(totalTributos) || 0;

    const totalB =
      data["b-TotalTributosSubDatas"]?.reduce(
        (sum, item) => sum + (parseFloat(item.description) || 0),
        0,
      ) || 0;

    const totalC =
      data["c-TotalTributosSubDatas"]?.reduce(
        (sum, item) => sum + (parseFloat(item.description) || 0),
        0,
      ) || 0;

    const totalGeneral = totalA + totalB + totalC;

    return {
      totalA,
      totalB,
      totalC,
      totalGeneral,
    };
  };

  const MyDoc = ({ data }) => {
    const aItems = data["a-TotalTributosSubDatas"] || [];
    const bItems = data["b-TotalTributosSubDatas"] || [];
    const cItems = data["c-TotalTributosSubDatas"] || [];

    aItems.forEach((item, index) => {
      const str = item.description2?.trim();
      if (str?.startsWith("{") && str.endsWith("}")) {
        try {
          const convert = JSON.parse(str);
          if (convert.notaValor) {
          }
        } catch (e) {
          // Silencio o log si prefieres
        }
      }
    });

    const totalDescription = notesValueData.reduce(
      (acum, item) => acum + parseFloat(item.description || 0),
      0,
    );
    // Obtener T/C, usando 6.96 si no existe
    const tipoCambio = parseFloat(
      notesValueData.find((item) => item.label === "T/C")?.description2 || 6.96,
    );
    const totalBs = roundUpCustom(totalDescription * tipoCambio);
    // Obtener porcentajes
    const ga = parseFloat(
      notesValueData.find((item) => item.label === "Porcentaje GA")
        ?.description2 || 10,
    ).toFixed(2);
    const iva = parseFloat(
      notesValueData.find((item) => item.label === "Porcentaje IVA")
        ?.description2 || 14.94,
    ).toFixed(2);
    const ice = parseFloat(
      notesValueData.find((item) => item.label === "Porcentaje ICE")
        ?.description2 || 0,
    ).toFixed(2);

    const datosNotas = [];
    const isValid = (val) => parseFloat(val) > 0;

    const impuestosNotas = [
      isValid(ga) && {
        label: "Gravamen Arancelario - GA",
        porcentaje: ga,
        importe: totalBs,
        impuesto: roundUpCustom((totalBs * parseFloat(ga)) / 100),
        total: roundUpCustom((totalBs * parseFloat(ga)) / 100),
      },
      isValid(iva) && {
        label: "Impuesto al valor Agregado - IVA",
        porcentaje: iva,
        importe: totalBs,
        impuesto: roundUpCustom(
          ((totalBs + parseFloat(ga)) * parseFloat(iva)) / 100,
        ),
        total: roundUpCustom(
          ((totalBs + parseFloat(ga)) * parseFloat(iva)) / 100,
        ),
      },
      isValid(ice) && {
        label: "Impuesto a los Consumos Específicos - ICE",
        porcentaje: ice,
        importe: totalBs,
        impuesto: roundUpCustom((totalBs * parseFloat(ice)) / 100),
        total: roundUpCustom((totalBs * parseFloat(ice)) / 100),
      },
      {
        label: "Formulario Digital",
        porcentaje: "0.00",
        importe: 100,
        impuesto: 0.0,
        total: 100,
      },
    ].filter(Boolean);

    const itemsMap = new Map();

    impuestosNotas.forEach((item) => {
      if (item) {
        itemsMap.set(item.label.trim().toLowerCase(), { ...item });
      }
    });

    aItems.forEach((itemA) => {
      const key = itemA.label.trim().toLowerCase();
      const itemExistente = itemsMap.get(key);

      if (itemExistente) {
        itemsMap.set(key, {
          ...itemExistente,
          label: itemA.label,
          importe: parseFloat(itemA.description) || itemExistente.importe,
          impuesto: parseFloat(itemA.description) || itemExistente.importe,
          total: parseFloat(itemA.description) || itemExistente.total,
        });
      } else {
        itemsMap.set(key, {
          label: itemA.label,
          porcentaje: "0.00",
          importe: parseFloat(itemA.description) || 0,
          impuesto: parseFloat(itemA.description) || 0,
          total: parseFloat(itemA.description) || 0,
        });
      }
    });

    const porcentajeNotas = Array.from(itemsMap.values());

    const totalPorcentajes =
      Math.round(
        porcentajeNotas.reduce((acum, item) => acum + item.total, 0) * 100,
      ) / 100;

    const totales = calculateTotals(data, totalPorcentajes);

    const obtenerFechaFormateada = () => {
      const fechaStr = data.fechaDeCotización; // la fecha de tu API
      if (!fechaStr) return "";

      // Parseamos la fecha como UTC para evitar desfases de zona horaria
      const fecha = new Date(fechaStr + "T00:00:00Z");

      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      const dia = fecha.getUTCDate(); // usamos getUTCDate
      const mes = meses[fecha.getUTCMonth()];
      const anio = fecha.getUTCFullYear();

      return `La Paz, ${dia} de ${mes} de ${anio}`;
    };

    function handleProcess(listNote) {
      let list =
        listNote && validateArray(listNote)
          ? listNote
              .filter((item) => !item.label?.includes("Porcentaje"))
              .filter((item) => !item.label?.includes("T/C"))
              .map((item) => ({
                label: item.label,
                description: item.description,
              }))
          : [];

      return list;
    }
    function handletc(listNote) {
      const tcItem = listNote.find((item) => item.label === "T/C");
      if (tcItem) {
        return tcItem.description2 || data.tipoDeCambioProforma || "6.96";
      }

      return data.tipoDeCambioProforma || "6.96";
    }
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.container}>
            <Image src={fondoURL} style={styles.bgImage} />
            <View style={styles.content}>
              <Text style={[styles.title, { marginBottom: "25" }]}>
                COTIZACIÓN - PROFORMA
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  padding: 4,
                }}
              >
                <View style={{ alignItems: "flex-start" }}>
                  <Text style={{ fontSize: 18, fontWeight: "600" }}>
                    {data.nroCotizacion}
                  </Text>
                  <Text>{obtenerFechaFormateada()}</Text>
                </View>
              </View>
              <View style={styles.line} />
              <View style={{ flexDirection: "row", padding: 4 }}>
                <View style={{ marginRight: 40 }}>
                  <Text style={{ fontSize: 11, fontWeight: "semibold" }}>
                    NIT
                  </Text>
                  <Text style={{ fontSize: 9 }}>{data.company.nit} </Text>
                </View>
                <View>
                  <Text style={{ fontSize: 11, fontWeight: "semibold" }}>
                    Importador/Exportdor
                  </Text>
                  <Text style={{ fontSize: 9 }}>
                    {data.company.razonSocial}{" "}
                  </Text>
                </View>
              </View>
              <View style={styles.line} />
              <View style={{ fontSize: 10, flexDirection: "row" }}>
                <View style={{ flex: 1, padding: 4 }}>
                  <Text
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      marginBottom: 4,
                    }}
                  >
                    Valor CIF Frontera
                  </Text>
                  <View>
                    {handleProcess(notesValueData).map((nota, index) => {
                      return (
                        <View
                          style={{ flexDirection: "row", padding: 2 }}
                          key={index}
                        >
                          <Text style={{ flex: 2, fontSize: 9 }}>
                            {" "}
                            {nota.label}{" "}
                          </Text>
                          <Text style={{ flex: 1, textAlign: "center" }}>
                            $us
                          </Text>
                          <Text style={{ flex: 1, textAlign: "right" }}>
                            {" "}
                            {nota.description}{" "}
                          </Text>
                        </View>
                      );
                    })}

                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        backgroundColor: "gray",
                        padding: 4,
                      }}
                    >
                      <Text style={{ flex: 2, color: "#f0f0f0" }}>
                        Valor CIF
                      </Text>
                      <Text
                        style={{
                          flex: 1,
                          textAlign: "center",
                          color: "#f0f0f0",
                        }}
                      >
                        $us
                      </Text>
                      <Text
                        style={{
                          flex: 1,
                          color: "#f0f0f0",
                          textAlign: "right",
                        }}
                      >
                        {" "}
                        {numberWithDecimals(Number(totalDescription))}
                      </Text>
                    </View>
                    <Text style={{ padding: 4, textAlign: "center" }}>
                      TC: {handletc(notesValueData)}
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        backgroundColor: "gray",
                        padding: 4,
                      }}
                    >
                      <Text style={{ flex: 2, color: "#f0f0f0" }}>
                        Valor CIF
                      </Text>
                      <Text
                        style={{
                          flex: 1,
                          textAlign: "center",
                          color: "#f0f0f0",
                        }}
                      >
                        Bs.
                      </Text>
                      <Text
                        style={{
                          flex: 1,
                          color: "#f0f0f0",
                          textAlign: "right",
                        }}
                      >
                        {" "}
                        {totalBs}{" "}
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    gap: 8,
                    padding: 6,
                    borderLeft: "1px solid black",
                  }}
                >
                  <View>
                    <Text style={{ fontWeight: "semibold" }}>
                      Descripción de las Mercancias
                    </Text>
                    <Text>
                      {data["descripciónDeLaMercancía"] || "Sin descripción"}
                    </Text>
                  </View>
                  <View>
                    <Text style={{ fontWeight: "semibold" }}>
                      Factura Comercial
                    </Text>
                    <Text>
                      {Array.isArray(
                        data["cm-003-FacturaComercialFileStates"],
                      ) && data["cm-003-FacturaComercialFileStates"].length > 0
                        ? data["cm-003-FacturaComercialFileStates"]
                            .map((item) => item.number)
                            .join("-")
                        : "Sin descripción"}
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row", gap: 6 }}>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text style={{ fontWeight: "semibold" }}>Bultos</Text>
                      <Text>{data.bultos || "0"}</Text>
                    </View>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text style={{ fontWeight: "semibold" }}>Peso</Text>
                      <Text>{data.peso || "0"}</Text>
                    </View>
                  </View>
                  <View style={{ flexDirection: "row", gap: 2 }}>
                    <Text style={{ fontWeight: "semibold" }}>Aduana</Text>
                    <Text>{data.a4AduanaDeDespacho}</Text>
                  </View>
                  <View style={{ flexDirection: "row", gap: 2 }}>
                    <Text style={{ fontWeight: "semibold" }}>Modalidad</Text>
                    <Text>
                      {data.asignarRégimenDeImportación || "Sin descripción"}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.line} />
              <View style={styles.section}>
                <View style={{ flexDirection: "row", gap: 2 }}>
                  <Text
                    style={{
                      flex: 2,
                      textAlign: "center",
                      backgroundColor: "gray",
                      padding: 4,
                      fontSize: 10,
                      color: "#f0f0f0",
                    }}
                  >
                    Concepto
                  </Text>
                  <Text
                    style={{
                      flex: 1,
                      textAlign: "center",
                      backgroundColor: "gray",
                      padding: 4,
                      fontSize: 10,
                      color: "#f0f0f0",
                    }}
                  >
                    Monto
                  </Text>
                </View>
                {/* tabla A */}
                <View>
                  <Text style={[styles.subTitle]}>TRIBUTOS ADUANEROS </Text>
                  {porcentajeNotas.map((item, index) => {
                    return (
                      <View key={index} style={styles.rowItem}>
                        <Text style={styles.smallText}>{item?.label}</Text>
                        <Text style={styles.lefText}>
                          {numberWithDecimals(Number(item.total))}
                        </Text>
                      </View>
                    );
                  })}
                </View>
                <View style={styles.subTotal}>
                  <Text>Sub Total:</Text>
                  <Text>Bs. {numberWithDecimals(totalPorcentajes)}</Text>
                </View>
                <View style={styles.line} />

                {/* Tabla B */}
                <View>
                  <Text style={[styles.subTitle]}>GASTOS DE OPERACION</Text>

                  {(bItems.length > 0 ? bItems : [{}]).map((item, index) => (
                    <View key={index} style={styles.rowItem}>
                      <Text style={styles.smallText}>{item?.label || ""}</Text>
                      <Text style={styles.lefText}>
                        {item?.description
                          ? numberWithDecimals(Number(item.description))
                          : ""}
                      </Text>
                    </View>
                  ))}
                </View>
                <View style={[styles.rowItem, styles.subTotal]}>
                  <Text style={styles.smallText}>Sub Total:</Text>
                  <Text style={[styles.lefText, styles.smallText]}>
                    Bs. {numberWithDecimals(totales.totalB)}
                  </Text>
                </View>

                <View style={styles.line} />

                {/* tabla C */}
                <View>
                  <Text style={[styles.subTitle]}>SERVICIOS AGENCIA </Text>

                  {(cItems.length > 0 ? cItems : [{}]).map((item, index) => (
                    <View key={index} style={styles.rowItem}>
                      <Text style={styles.smallText}>{item?.label || ""}</Text>
                      <Text style={styles.lefText}>
                        {numberWithDecimals(Number(item?.description))}
                      </Text>
                    </View>
                  ))}
                </View>
                <View style={[styles.rowItem, styles.subTotal]}>
                  <Text>Sub Total:</Text>
                  <Text style={styles.lefText}>
                    Bs. {numberWithDecimals(totales.totalC)}
                  </Text>
                </View>

                <View style={styles.line} />

                {/* Total General */}
                <View>
                  <View
                    style={[
                      styles.rowItem,
                      { paddingTop: 15 },
                      styles.smallText,
                    ]}
                  >
                    <Text> TOTAL COTIZACION</Text>
                    <Text>Bs. {numberWithDecimals(totales.totalGeneral)}</Text>
                  </View>
                  <Text style={[styles.smallText, { paddingTop: 15 }]}>
                    {/* SON: {totalCotizacionLetras.toString()} 00/100 BOLIVIANOS{" "} */}
                  </Text>
                  <Text style={styles.smallText}>Válido por 7 días</Text>
                </View>
              </View>
              <View>
                {/* <Text style={styles.important}>IMPORTANTE</Text> */}

                {/* <Text style={styles.text}>
                    Para su mayor comodidad, Ud. puede efectuar el depósito del monto señalado en nuestra Cta. Bs.: 10000029719230
                    en el Banco Unión S.A. a nombre de Agencia Despachante de Aduanas PATROSS S.R.L. haciendo referencia a la presente Planilla.
                  </Text>
                  <Text style={styles.warning}>
                    Pasado las 48 Horas de la emisión de la planilla no se aceptan reclamos o devoluciones.
                  </Text> */}
              </View>
              {/* <View style={{textAlign:"center", fontSize:"14px", marginVertical:24}}>
                    <Text>Nuestra mejor referencia en servicios es Usted!!!</Text>
                </View> */}
            </View>
            <View style={styles.footer}>
              <View style={{ flex: 1, textAlign: "center", marginLeft: 30 }}>
                <Text style={[styles.smallText, { marginBottom: "10" }]}>
                  UBICACIÓN:
                </Text>
                <Text style={{ fontSize: 8 }}>
                  AV. 16 DE JULIO, EDIFICIO HERMANN, PISO 18
                </Text>
                <Text style={{ fontSize: 8 }}>
                  DPTO A NRO.1440 - TELEFONO: 2409866 -{" "}
                </Text>
                <Text style={{ fontSize: 8 }}>2406093 FAX:(591+2) 2407490</Text>
                <Text style={{ fontSize: 8 }}>LA PAZ - BOLIVIA</Text>
              </View>

              <View style={{ flex: 1, textAlign: "center" }}>
                <Text style={[styles.smallText, { marginBottom: "10" }]}>
                  BANCO UNION S.A.
                </Text>
                <Text style={{ fontSize: 8 }}>NÚMERO DE CUENTA:</Text>
                <Text style={{ fontSize: 8 }}>CTA. BS.: 10000029719230</Text>
              </View>

              <View style={{ flex: 1, textAlign: "center" }}>
                <Text style={[styles.smallText, { marginBottom: "10" }]}>
                  BENEFICIARIO:
                </Text>
                <Text style={{ fontSize: 8 }}>A.D.A. PATROSS S.R.L.</Text>
                <Text style={{ fontSize: 8 }}>(591) 76504040</Text>
              </View>
            </View>
            <View style={{ marginLeft: "25%" }}>
              <Image
                src="https://res.cloudinary.com/dh15miacl/image/upload/qr_nbew7h.png"
                style={{ width: 90, height: 90, position: "absolute" }}
              />
            </View>
          </View>
        </Page>
      </Document>
    );
  };
  return (
    <div>
      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDoc data={data} />
        </PDFViewer>
      )}
    </div>
  );
};

export default CustomsClearanceQuote;
